import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { AttachFile } from '@material-ui/icons'
import PrintIcon from '@material-ui/icons/Visibility'
import { AttachmentDialog } from 'components/Dialog/AttachmentDialog'
import { useDocumentListingQuery } from 'generated/graphql'
import { AttachmentDetailView } from 'helpers/Hooks/attachmentDetailsView'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  documentListing?: any
  mode?: string
}

export const AssetsCountDetailContent = (props: DetailProps) => {
  const history = useHistory()
  const { CompanyID }: any = useParams()
  const { listEl, documentListing, listStatus, userList, mode } = props
  const [openDoc, setOpenDoc] = useState<boolean>(false)
  const { menu } = useMenuOption()

  const countDetails = listEl?.CountDetails || []
  const totalItems = countDetails.length
  const countedItems = countDetails.filter(
    d => d.counted_qty !== null && d.counted_qty !== undefined
  ).length
  const discrepancies = countDetails.filter(
    d => Number(d.counted_qty) !== Number(d.asset_qty)
  ).length
  const totalVariance = countDetails.reduce(
    (sum, d) => sum + (Number(d.counted_qty) - Number(d.asset_qty)),
    0
  )

  const getUserName = (userId: string) => {
    const user = userList?.find(u => u.ID === userId)
    return user?.name || 'N/A'
  }

  return (
    <>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Category
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.Category?.name || 'N/A'}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Count Date
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.count_date)}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Total Items
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {totalItems}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Items Counted
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {countedItems}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Discrepancies
        </div>
        <div
          className="mdDesc text-noflow"
          style={{
            fontSize: '11px',
          }}
        >
          {discrepancies}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Total Variance
        </div>
        <div
          className="mdDesc text-noflow"
          style={{
            fontSize: '11px',
          }}
        >
          {totalVariance > 0 ? '+' : ''}
          {totalVariance}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Submitted By
        </div>
        <div className="mdDesc text-noflow">
          {getUserName(listEl?.submittedBy)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Submitted Date
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.submittedTs)}
        </div>
      </div>

      {listStatus === 'COMPLETED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Approved By
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {getUserName(listEl?.approvedBy)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Approved Date
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.approvedTs)}
            </div>
          </div>
        </>
      )}

      {listStatus === 'REJECTED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Rejection Date
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.RejectionDate)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Rejection Remark
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {listEl?.RejectionRemark || 'N/A'}
            </div>
          </div>
        </>
      )}

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Remark
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.remark || 'No remark'}
        </div>
      </div>
    </>
  )
}
